import { useState, useEffect } from "react";

const ReadingProgressBar = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [showClose, setShowClose] = useState(false);

  const calculateScrollDistance = () => {
    const totalHeight =
      document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercent = (window.scrollY / totalHeight) * 100;
    setScrollPosition(scrollPercent);
  };

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem("hideProgressBar", "true");
  };

  // Check if NotFoundPage is being displayed
  const isNotFoundPage = () => {
    // Check if the not-found-page class exists (from NotFoundPage component)
    return document.querySelector('.not-found-page') !== null;
  };

  useEffect(() => {
    if (sessionStorage.getItem("hideProgressBar") === "true") {
      setIsVisible(false);
    }

    // Check for NotFoundPage on mount and when DOM changes
    const checkForNotFound = () => {
      if (isNotFoundPage()) {
        setIsVisible(false);
      }
    };

    // Initial check
    checkForNotFound();

    // Use MutationObserver to watch for NotFoundPage being added to DOM
    const observer = new MutationObserver(checkForNotFound);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    window.addEventListener("scroll", calculateScrollDistance);
    return () => {
      window.removeEventListener("scroll", calculateScrollDistance);
      observer.disconnect();
    };
  }, []);

  // Hide if NotFoundPage is visible
  if (!isVisible || isNotFoundPage()) {
    return null;
  }

  return (
    <div
      className="reading-progress-bar"
      onMouseEnter={() => setShowClose(true)}
      onMouseLeave={() => setShowClose(false)}
    >
      <div
        className="progress-indicator"
        style={{ width: `${scrollPosition}%` }}
      ></div>
      {showClose && (
        <span
          onClick={handleClose}
          className="close-btn animate__animated animate__fadeInRight"
        >
          <span className="material-symbols-outlined notranslate">close</span>
        </span>
      )}
    </div>
  );
};

export default ReadingProgressBar;
